import { useEffect } from 'react';
import { useMap } from 'react-map-gl/mapbox';

import type { FeatureCollection, Point } from 'geojson';

import { MAX_ZOOM_IN } from '@/utils/constants/map';

const useStationPinAnimation = (
  stationGeoJson: FeatureCollection | null,
  pinnedItemId: string | null
) => {
  const { current: map } = useMap();

  useEffect(() => {
    if (!map || !pinnedItemId || !stationGeoJson?.features?.length) {
      return;
    }

    const stationFeature = stationGeoJson.features.find(
      (feature) => feature.properties?.id === pinnedItemId && feature.geometry.type === 'Point'
    );

    if (!stationFeature) {
      return;
    }

    const center = (stationFeature.geometry as Point).coordinates as [number, number];

    map.flyTo({
      center,
      zoom: MAX_ZOOM_IN,
      pitch: 0,
      bearing: 0,
      duration: 1500,
      essential: true,
    });
  }, [map, pinnedItemId, stationGeoJson]);
};

export default useStationPinAnimation;
